import cn from 'classnames';
import React from 'react';
import { ResponsiveTheme } from '../hocs/ResponiseStyles/withResponsiveStyles';
import { Skeleton } from '../Skeleton';
import styles from './hero.module.sass';

interface HeroBlockProps extends React.HTMLAttributes<HTMLDivElement> {
    picture?: string | React.ReactElement;
    heading?: string | React.ReactNode;
    isLoading?: boolean;
    compact?: boolean;
    minHeight?: boolean;
    detail?: boolean;
    theme?: ResponsiveTheme;
    blurred?: boolean;
}

export const HeroBlock = ({
    picture,
    heading,
    isLoading,
    compact,
    minHeight,
    detail,
    blurred,
    children,
    className,
}: HeroBlockProps) => {
    if (isLoading) {
        return (
            <div className={cn(styles.picture, className)}>
                <Skeleton absolute />
                <div className={styles.imageSkeleton}></div>
                <div className={styles.heading}>
                    <Skeleton />
                </div>
            </div>
        );
    }
    return (
        <div className={cn(styles.holder, className)}>
            <div
                className={cn(
                    styles.picture,
                    compact && styles.compact,
                    minHeight && styles.minHeight,
                    detail && styles.detail,
                    blurred && styles.blurred
                )}
            >
                {typeof picture === 'string' ? (
                    <img src={picture} alt={typeof heading === 'string' ? heading : ''} />
                ) : (
                    picture
                )}
                <div className={styles.inner}>
                    {blurred && typeof picture === 'string' && (
                        <div className={styles.poster}>
                            <img src={picture} alt="" />
                        </div>
                    )}
                    {typeof heading === 'string' ? (
                        <strong className={styles.heading}>{heading}</strong>
                    ) : React.isValidElement<React.HTMLAttributes<HTMLElement>>(heading) ? (
                        React.cloneElement(heading, {
                            className: `${heading.props.className || ''} ${styles.heading}`.trim(),
                        })
                    ) : (
                        heading
                    )}
                </div>
                {/* {children} */}
            </div>
            {children && <div className={styles.content}>{children}</div>}
        </div>
    );
};
